// TODO - don't know what this was intended to be.
Jelly.Interface.Lock = function()
{	
	Jelly.Interface.Is_Locked = true;
	$("html").addClass("Scroll_Lock");
};